import * as React from 'react';


import { useNavigate } from 'react-router-dom';


import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Backdrop from '@mui/material/Backdrop';

import CircularProgress from '@mui/material/CircularProgress';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import PersonIcon from '@mui/icons-material/Person';

import { styled } from '@mui/material/styles';

import Top from "../Top";
import Bottom from "../Bottom";

import tab04 from "../../assets/images/tab_01.png"


const Terms = () => {

  const navigate = useNavigate();




  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const img = {
    display: 'flex', p: 0, backgroundImage: `url(${tab04})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
  }

  return (
    <Container className="container">
      <Box sx={img} className='topImg'>
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900 }}>
              이용안내
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              서비스 이용약관
            </Typography>
          </Grid>
        </Grid>
      </Box>


      <Box className={'contentStart'}
        sx={{
          p: '0 15px 80px 15px',
          mt: 10,
          '& > p': {
            margin: '6px',
            fontSize: 12,
          },
          'p.font12': { fontSize: 12, fontWeight: 'normal' },
          'ol': { paddingLeft: '20px' },
          'ul': { paddingLeft: '20px' },
          'li': { fontSize: 12 },
          'h2': { textAlign: 'center', fontSize: 24 },
          'h3': { fontSize: 14 },

        }}>

        <h2>듀얼헬스케어 서비스 이용약관</h2>
        <p>&nbsp;</p>

        <h3>제1조(목적)</h3>

        <p>이 약관은 ㈜듀얼헬스케어 (이하 “회사”라 함)이 제공하는 서비스의 이용과 관련하여 "회사"와 "이용자(이하 또는 “회원”이라 함)"와의 권리,
          의무 및 책임사항, 이용조건 및 절차 등 기본적인 필요사항을 규정함을 목적으로 합니다.</p>

        <p>&nbsp;</p>
        <h3>제2조 (용어의 정의)</h3>
        <ol>
          <li>이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
            <ol>
              <li>이용자 : 회사에서 제공하는 서비스 또는 관련 제반 서비스를 이용하는 "회원"과 "비회원"을 말합니다.
              </li>
              <li>회원 : 회사의 서비스에 접속하여 이 약관에 따라 회사와 "이용계약"을 체결하고 회사가 제공하는 서비스를 이용하는 고객을 말합니다.
              </li>
              <li>이용계약 : 이 약관을 포함하여 서비스 이용과 관련하여 "회사"와 "회원” 간에 체결하는 모든 계약을 말합니다.
              </li>
              <li>서비스 : 회사가 이용자에게 인터넷을 통해 제공하는 서비스를 말합니다.
              </li>
              <li>"아이디(ID)"라 함은 회원의 식별과 서비스 이용을 위하여 회원이 정하고 회사가 승인하는 문자와 숫자의 조합을 말합니다.
              </li>
              <li>"비밀번호"라 함은 회원이 부여 받은 아이디와 일치되는 회원임을 확인하고 비밀보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합을 의미합니다.
              </li>
              <li>“유료 서비스”란 회사가 제공하는 서비스 중 비용이 발생되는 각종 부가 서비스를 의미합니다.
              </li>
              <li>“해지"라 함은 회사 또는 회원이 "이용계약"을 해약하는 것을 말합니다.
              </li>
              <li>”게시물“이라 함은 이용자가 서비스를 이용함에 있어 서비스상에 게시한 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.
              </li>
              <li>“맞춤형 건강관리 서비스”란 “회사”가 회원에게 건강정보를 제공하기 위한 서비스로 회원이 저장한 의료정보, 생활습관정보 등 회원이 자신의 건강정보를 확인하고 건강을 관리하는데 도움을 주기 위한 서비스를 말합니다.
              </li>
            </ol>
          </li>
          <li>이 약관에서 사용하는 용어 중 제 2조에서 정하지 아니한 것은 관계 법령 및 서비스별 안내에서 정하는 바에 따르며, 그 외에는 일반 관례에 따릅니다.</li>
        </ol>
        <p>&nbsp;</p>

        <h3>제3조 (약관의 게시와 개정)</h3>
        <p className='font12'>회사는 이 약관의 내용을 이용자가 쉽게 알 수 있도록 모바일 어플리케이션과 웹사이트에 게시합니다.</p>
        <p className='font12'>회사는 "약관의 규제에 관한 법률", "정보통신망이용촉진 및 정보보호 등에 관한 법률(이하 "정보통신망법")" 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</p>
        <p className='font12'>회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 제1항의 방식에 따라 그 개정약관의 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 이용자에게 불리한 약관 개정의 경우에는 그 적용일자 30일 전부터 공지하고, 공지 외에 일정기간 서비스 내 로그인 시 동의 창 등의 전자적 수단을 통해 따로 명확히 통지하도록 합니다.</p>
        <p className='font12'>회사가 전항에 따라 개정약관을 공지 또는 통지하면서 이용자에게 7일 또는 30일 기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 이용자가 명시적으로 거부의 의사표시를 하지 아니한 경우 이용자가 개정약관에 동의한 간주되며 효력이 발생합니다.</p>
        <p className='font12'>이용자가 개정약관의 적용에 동의하지 않는 경우 회사는 개정 약관의 내용을 적용할 수 없으며, 이 경우 이용자는 이용계약을 해지할 수 있습니다. 다만, 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에 회사는 이용계약을 해지할 수 있습니다.</p>
        <p className='font12'>회원이 이 약관의 내용에 동의한 경우 회사의 서비스 제공 행위 및 회원 서비스 이용 행위에는 이 약관이 우선적으로 적용이 됩니다. 이 약관에 명시되지 않은 사항에 대해서는 전기통신기본법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 정보통신윤리위원회 심의 규정, 정보통신 윤리강령, 프로그램 보호법 등 기타 대한민국의 관련 법령과 상관습에 의합니다.</p>


        <p>&nbsp;</p>

        <h3>제4조 (약관의 해석)</h3>
        <p className='font12'>회사는 개별 서비스에 대해서는 별도의 이용약관 및 정책(이하 서비스 별 이용약관 또는 정책)을 둘 수 있으며, 해당 내용이 이 약관과 상충할 경우에는 "서비스 별 이용약관 또는 정책"을 우선하여 적용합니다.</p>
        <p className='font12'>이 약관에서 정하지 아니한 사항이나 해석에 대해서는 관계법령 또는 상관례에 따릅니다.</p>

        <p>&nbsp;</p>
        <h3>제5조 (서비스 이용 신청 및 계약의 성립)</h3>
        <ol>
          <li>서비스 이용을 신청하는 경우 회사가 요청하는 소정의 회원가입 양식을 기록하여 신청해야합니다. </li>
          <li>가입신청 양식에 기재되는 모든 회원의 정보는 실제 데이터인 것으로 간주됩니다. 만일, 실명이나 실제 정보를 입력하지 않은 경우, 이용자는 법적인 보호를 받을 수 없으며 서비스 사용에 제한을 받으실 수 있습니다.  </li>
          <li>서비스 가입은 회원의 이용 신청에 대한 회사의 이용 긍낙과 이용자가 회원 가입을 신청할 때 본 약관을 읽고 “동의함” 버튼을 클릭하여야 합니다. 다만 회사는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용 계약을 해지 할 수 있습니다.
            <ol>
              <li>허위 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우</li>
              <li>타인의 명의를 이용한 경우</li>
              <li>회원의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 상을 위반하며 신청하는 경우</li>
              <li>정보를 악용하거나 사회의 안녕과 질서 혹은 미풍양속을 저해할 목적으로 신청한 경우</li>
              <li>만 14세 미만의 아동인 경우</li>
            </ol>
          </li>
          <li>회사는 제3항의 규정에 의하여 승낙이 거절되거나 제한 또는 유보되는 경우, 이용을 신청한 자에게 이를 즉시 알려야 합니다. 다만, 이용을 신청한 자의 고의 또는 과실 등으로 통지할 수 없는 경우에는 그러하지 아니합니다.
          </li>
          <li>이용계약의 성립 시기는 회사가 가입완료를 신청절차 상에서 표시한 시점으로 합니다.
          </li>
          <li>회사는 이용자에 대해 회사 정책에 따라 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다.</li>
        </ol>

        <p>&nbsp;</p>
        <h3>제6조 (회원정보의 변경)</h3>
        <p className='font12'>회원은 회원정보관리를 통해 언제든지 자신의 정보를 열람하고 수정할 수 있습니다. 다만, 회원의기본 신상정보(생년월일 등)은 수정이 불가능합니다. 회원은 이용 신청 시 기재한 사항이 변경되었을 때 수정을 해야 하며, 수정하지 아니하여 발생하는 문제의 책임은 회원에게 있습니다. </p>
        <p>&nbsp;</p>

        <h3>제7조(서비스 이용)</h3>
        <ol>
          <li>회사가 이용자에게 제공하는 서비스는 아래와 같습니다.
            <ol>
              <li>건강검진병원의 정보를 제공하는 서비스 : 건강검진병원/센터찾기, 예방접종가능 병원찾기 등
              </li>
              <li>의료정보를 제공하는 서비스 : 질병정보, 검사정보, 의약품정보, 자가진단, 건강상담, 건강뉴스 등
              </li>
              <li>의료기관의 이벤트 제공 서비스 : 의료기관 광고 이벤트 제공, 이벤트 신청관리 등
              </li>
              <li>회원의 동의 하에 수집하거나 입력된 정보를 확인 할 수 있는 서비스 : 건강검진센터 방문 내역, 예약 내역, 건강검진센터가 제공한 회원의 검진결과/상담내역 및 회원이 기록 저장한 생활습관정보 등
              </li>
              <li>맞춤형 건강검진 추천 및 추천 건강검진 상품 신청 및 건강관리 내역
              </li>
              <li>건강검진예약 신청 및 건강검진 이벤트 신청 시 알림톡 서비스
              </li>
              <li>헬스케어 상품 및 서비스 별 혜택 정보 제공 및 기타 회사가 개발하거나 다른 회사와의 협력을 통해 제공하는 서비스
              </li>
            </ol>
          </li>
          <li>회원은 회사에서 제공하는 서비스를 모두 이용할 수 있으며 다만 유료서비스는 별도의 절차를 거쳐야 합니다.  </li>
          <li>무료 서비스는 회사의 정책, 기획이나 운영 방안 또는 회사의 긴박한 상황 등에 따라 중단 및 변경될 수 있으며, 이에 대하여 관련 법령상 특별한 규정이 없는 한 이용자에게 별도의 보상을 하지 않습니다.
            회사는 업무 수행상 필요하다고 판단되는 경우 서비스 내용을 추가하거나 변경 또는 서비스 종료를 할 수 있으며, 이 경우 서비스 변경 내용을 미리 모바일 어플리케이션이나 웹사이트에 게시하거나 이용자에게 개별 통지합니다.
          </li>
          <li>유료 서비스의 변경 내용이 중대하거나 이용자에게 불리한 경우 해당 유료 서비스를 제공받는 이용자에게 이용자가 지정한 이메일 주소로 통지합니다. 이 경우 동의를 거절한 이용자에 대해서는 변경 전 서비스를 제공합니다. 다만, 변경 전 서비스의 제공이 불가능한 경우 회사는 서비스 제공을 중지하거나 관련 규정에 따라 환불을 진행합니다. </li>
        </ol>

        <p>&nbsp;</p>
        <h3>제8조(서비스 이용의 제한)</h3>
        <ol>
          <li>회사는 다음 각호에 해당하는 경우 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다.
            <ol>
              <li>서비스용 설비의 부수 등 공사로 인한 부득이한 경우
              </li>
              <li>전기통신사업법에 규정된 기간통신사업자가 전기통신서비스를 중단했을 때
              </li>
              <li>국가비상사태, 정전, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우
              </li>
              <li>회원이 회사에 정확한 신상정보나 자료를 제공하지 않음으로써 발생되는 서비스의 제한의 경우
              </li>
              <li>기타 불가항력적 사유가 있는 경우
              </li>
            </ol>
          </li>
          <li>회사는 서비스의 이용을 제한하거나 중지한 때에는 그 사유와 제한기간 등을 회원에게 알리도록 합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다. </li>
        </ol>


        <p>&nbsp;</p>
        <h3>제9조 (서비스 이용요금)</h3>
        <ol>
          <li>회사가 제공하는 서비스는 별도 표시가 없는 한 무료로 제공됩니다. 별도 표시가 있는 유료 서비스는 명시된 요금을 지불하여야 사용 가능합니다.
            <ol>
              <li>회사는 유료 서비스 이용 요금을 회사와 계약한 전자지불업체에서 정한 방법에 의하거나 회사가 정한 청구서에 합산하여 청구할 수 있습니다.</li>
              <li>이용자의 개인정보도용 및 결제사기로 인한 환불요청 또는 결제자의 개인정보 요구는 법률이 정한 경우 외에는 거절될 수 있습니다.</li>
              <li>무선 서비스 이용 시 발생하는 데이터 통신료는 별도이며 가입한 각 이동통신사의 정책에 따릅니다.</li>
              <li>MMS 등으로 게시물을 등록할 경우 발생하는 요금은 이동통신사의 정책에 따릅니다.</li>
              <li>유료 서비스 이용을 통하여 결제된 대금에 대한 취소 및 환불은 회사의 결제 이용약관 등 관계법에 따릅니다.</li>
            </ol>
          </li>
        </ol>
        <p>&nbsp;</p>

        <p>제10조 (개인정보보호 의무)</p>
        <ol>
          <li>회사는 “개인정보보호법”, “정보통신망법” 등 관계 법령이 정하는 바에 따라 이용자의 개인정보를 보호하기 위해 노력합니다.</li>
          <li>개인정보의 보호 및 사용에 대해서는 관련법 및 회사의 개인정보처리방침이 적용됩니다. 다만, 회사의 공식 사이트 이외의 링크된 사이트에서는 회사의 개인정보처리방침이 적용되지 않습니다.</li>
          <li>아이디와 비밀번호에 관한 모든 관리 책임은 회원에게 있고 회원에 가입하여 서비스를 이용하고자 하는 희망자는 회사에서 요청하는 개인신상정보를 제공해야 합니다. 회원에게 부여된 아이디와 비밀번호의 관리 소홀, 부정사용에 의하여 발생하는 모든 결과에 대한 책임은 회원에게 있습니다. </li>
          <li>자신의 아이디를 제3자에게 사용하도록 할 수 없으며 자신의 아이디가 부정하게 사용된 것을 발견한 경우 회원은 반드시 즉시 회사에 그 사실을 통보해야 합니다.</li>
          <li>회원은 서비스의 일부로 보내지는 전자우편을 받는 것에 동의합니다. </li>
          <li>회원은 이 약관 및 관계법령에서 규정한 사항을 준수해야 합니다.</li>
          <li>회사는 개인의 신분 확인이 가능한 정보를 회원 또는 이용자의 사전 허락없이 회사와 관계가 없는 제3자에게 제공하거나 판매할 수 없습니다. </li>
          <li>회사는 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우 특정 개인을 식별할 수 없는 형태로 회원의 정보를 이용하거나 제3자에게 제공할 수 있습니다.</li>
        </ol>
        <p>&nbsp;</p>

        <h3>제11조 (이용자에 대한 통지)</h3>
        <ol>
          <li>회사가 이용자에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 서비스 내 페이지, 전자우편주소, 전자쪽지 등으로 할 수 있습니다.</li>
          <li>회사는 이용자 전체에 대한 통지의 경우 7일 이상 회사의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.</li>
        </ol>
        <p>&nbsp;</p>

        <p>제12조 (회원의 아이디 및 비밀번호의 관리에 대한 의무)</p>
        <ol>
          <li>회원의 아이디와 비밀번호에 관한 관리 책임은 회원에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다.</li>
          <li>회원은 아이디 및 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 회사에 통지하고 회사의 안내에 따라야 합니다.</li>
          <li>제 2항의 경우에 해당 회원이 회사에 그 사실을 통지하지 않거나, 통지한 경우에도 회사의 안내에 따르지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.</li>
          <li>회원의 아이디는 원칙적으로 변경이 불가하며 부득이한 사유로 인하여 변경하고자 하는 경우에는 해당 아이디를 해지하고 재가입해야 합니다.</li>
          <li>서비스의 회원 아이디는 회원 본인의 동의 하에 회사 또는 자회사가 운영하는 사이트의 회원 아이디와 연결될 수 있습니다.</li>
          <li>회원의 아이디는 다음 각 호에 해당하는 경우에는 회원의 요청 또는 회사의 직권으로 변경 또는 이용을 정지할 수 있습니다.
            <ol>
              <li>회사는 회원의 아이디가 전화번호 등으로 등록되어 개인정보 유출이 우려되는 경우</li>
              <li>타인에게 혐오감을 주거나 반사회적 미풍양속에 어긋나는 경우</li>
              <li>회사 및 회사의 운영자로 오인할 우려가 있는 경우</li>
              <li>기타 합리적인 사유가 있는 경우</li>
            </ol>
          </li>
        </ol>
        <p>&nbsp;</p>

        <h3>제13조 (회사의 의무)</h3>
        <ol>
          <li>회사는 관련법을 준수하며 이 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 지속적으로 안정적인 서비스를 제공하기 위하여 최선을 다하여 노력합니다.</li>
          <li>회사는 서비스의 가감이 있을 경우 회원에게 그 내용을 통지해야 합니다. </li>
          <li>회사는 이용자가 안전하게 서비스를 이용할 수 있도록 개인정보를 보호하기 위해 최선을 다해야 하며 이용자의 본인의 승낙없이 타인에게 누설, 배포할 수 없습니다. 다만, 전기통신관련 법령 등 관계법령에 의하여 관계 국가기관 등의 요구가 있는 경우에는 그러하지 아니합니다. </li>
          <li>회사는 서비스 이용과 관련하여 이용자로부터 제기되는 의견이나 불만이 정당하다고 객관적으로 인정될 경우에는 적절한 절차를 거쳐 이를 처리하여야 합니다. 이용자가 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 이용자에게 처리과정 및 결과를 전달합니다.</li>
        </ol>
        <p>&nbsp;</p>

        <h3>제14조(회사 책임의 제한)</h3>
        <ol>
          <li>회사는 회원에 대한 개인 자료가 상담자와 서비스 관리자를 제외한 제3자에게 유출되지 않도록 보안을 유지합니다. 그러나 아래와 같은 경우에는 상담 내용 공개 및 상실에 대하여 회사의 책임이 없습니다.
            <ol>
              <li>이용자의 부주의로 암호가 유출되어 상담내용 등이 공개되었을 경우</li>
              <li>천재지변이나 그 밖에 회사가 통제할 수 없는 상황에 의하여 개인정보 상담 내용 등이 공개되거나 상담내용이 상실되었을 경우</li>
              <li>이용자 외의 제3자의 불법행위로 인하여 개인정보 및 상담내용 등이 공개된 경우</li>
            </ol>
          </li>
          <li>서비스에서 진행된 상담의 내용은 개인 신상정보를 삭제한 다음 학술활동, 인쇄물 등의 저작활동, FAQ등의 서비스 내용의 일부로 사용할 수 있습니다. </li>
          <li>상담에 대한 답변 내용은 각 전문 의료진의 의학 지식을 바탕으로 한 주관적인 답변이므로 회사의 서비스 의견을 대표하지 않습니다. </li>
          <li>인터넷 상에 제공하는 검진 결과는 각 협력 검진 기관에서 회원의 동의 하에 회사에 제공하는 것이며 회사가 제공하는 검진 결과 및 상담내용은 의학적인 일반적 권고 사항 및 참고 사항에 불과한 것입니다. 회원의 의학적인 건강 상태는 반드시 병원의 감당의사의 판정 소견에 따라야 합니다. </li>
          <li>협력 의료기관의 의료행위로 인한 결과에 대해서 회사는 책임을 지지 않습니다. </li>
          <li>회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</li>
          <li>회사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</li>
          <li>회사는 이용자가 서비스와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.</li>
          <li>회사는 이용자 간 또는 이용자와 제3자 상호간에 서비스를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.</li>
          <li>회사는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다</li>
        </ol>
        <p>&nbsp;</p>

        <h3>제15조 (이용자의 의무)</h3>
        <ol>
          <li>회원은 서비스 이용을 위하여 이용신청 단계에서 회사가 정하는 바에 따라 개인 정보를 등록해야 하며 정보의 허위로 인한 서비스의 제한은 전적으로 회원에게 있습니다. 회원의 정보가 변경되면 즉시 회사에 알려야 합니다. </li>
          <li>인터넷상에 제공되는 서비스의 내용은 개략적이며 일반적인 내용으로서 도움이 되는 정보 제공에 한정됩니다. 회원의 건강상태에 관한 의문점이나 걱정이 있다면 전문의사를 찾아 진단을 받아야 합니다. 어떠한 경우에도 서비스에서 제공하는 정보 때문에 의학적 진단을 무시하거나 진료받는 것을 미루어서는 안됩니다. </li>
          <li>회사는 서비스에서 언급된 어떠한 특정한 검사나 제품 혹은 치료법을 추천하지 않습니다. 서비스에 표현된 의견은 정보 제공의 목적이며 회사는 회원이 선택한 특정 검사, 제품 혹은 치료법의 대한 책임을 지지 않습니다. </li>
          <li>이용자는 자신의 아이디와 비밀번호를 제3자에게 사용하게 하거나, 누설, 방치하여서는 안됩니다. 이용자는 자신의 비밀번호를 주기적으로 변경하는 등 접근매체의 도용이나 위조 또는 변조를 방지하기 위하여 충분한 주의를 기울여야 합니다.</li>
          <li>이용자는 접근매체의 훼손, 분실, 도난 등의 사고가 발생하는 경우 즉시 그 사고 사실을 서면 또는 회사의 전화번호로 회사에 통지하여야 합니다.</li>
          <li>이용자는 다음 각호의 행위를 하지 않아야 할 의무가 있습니다.
            <ol>
              <li>신청 또는 변경 시 허위내용의 등록</li>
              <li>타인의 정보 도용 </li>
              <li>타인과의 관계를 허위로 명시하는 행위</li>
              <li>회사 및 타인을 비방할 목적으로 사실 또는 허위의 사실을 적시하여 명예를 훼손시키거나 업무를 방해하는 행위</li>
              <li>회사가 게시한 정보의 변경</li>
              <li>회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
              <li>회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
              <li>서비스에서 얻은 정보를 어떠한 형식으로든지 회사의 사전승낙 없이 회원의 이용이외의 목적으로 복제하거나 이를 출판 및 방송 등에 사용하거나 제3자에게 제공하거나 영리적으로 이용하는 행위</li>
              <li>공공질서 및 미풍양속에 위반되는 내용을 타인에게 유포하는 행위</li>
              <li>범죄와 결부된다고 객관적으로 판단되는 행위</li>
              <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위</li>
              <li>회사의 동의 없이 영리를 목적으로 서비스를 사용하는 행위</li>
              <li>기타 불법적이거나 부당한 행위</li>
            </ol>
          </li>
          <li>회원은 회원가입 신청 또는 회원정보 변경 시 모든 사항을 사실에 근거하여 본인의 진정한 정보로 작성하여야 하며, 허위 또는 타인의 정보를 등록할 경우 이와 관련된 모든 권리를 주장할 수 없습니다. </li>
          <li>이용자는 회사의 사전 승낙 없이 서비스를 이용하여 영업활동을 할 수 없으며, 그 영업활동의 결과에 대해 회사는 책임을 지지 않습니다. 또한 이용자는 이와 같은 영업활동으로 회사가 손해를 입은 경우, 이용자는 회사에 대해 손해배상의무를 지며, 회사는 해당 이용자에 대해 서비스 이용제한 및 적법한 절차를 거쳐 손해배상 등을 청구할 수 있습니다.</li>
          <li>회원은 회사의 명시적 동의가 없는 한 서비스의 이용권한, 기타 이용계약상의 지위를 타인에게 양도, 증여할 수 없으며 이를 담보로 제공할 수 없습니다.</li>
          <li>이용자는 회사 및 기타 제3자의 지적 재산권을 포함한 제반 권리를 침해하는 행위를 해서는 안 됩니다.</li>
        </ol>
        <p>&nbsp;</p>

        <h3>제16조 (정보의 제공 및 광고의 게재)</h3>
        <ol>
          <li>회사는 회원이 서비스를 이용할 때 필요하다고 인정되는 다양한 정보의 추가 또는 변경 내용이나 운영함에 있어 각종 정보 필요 정보를 서비스 화면에 게재하거나 문자메시지, 전자우편, 어플리케이션 Push 알림 등의 방법으로 이용자에게 제공할 수 있습니다.</li>
          <li>회원이 회사에서 제공하는 건강검진 관련 서비스(검진예약, 결과조회, 건강상담 등)를 이용할 경우 회원은 회사 및 협력 검진 기관 간에 자신의 건강 정보를 상호 공유 및 조회 할 수 있도록 사전에 동의한 것으로 봅니다. </li>
          <li>회사는 서비스의 운영과 관련하여 홈페이지, 서비스화면, 문자메시지, 전자우편, 어플리케이션 Push 알림 등에 광고 등을 게재할 수 있습니다. 이용자는 서비스 이용 시 노출되는 광고게재에 대해 동의하는 것으로 간주됩니다. 다만, 회사가 광고 등을 문자메시지, 전자우편, 어플리케이션 Push 알림 등을 이용하여 발송하는 경우 수신 동의 여부를 확인한 후 수신 동의한 이용자에 한하여 이를 발송합니다.</li>
          <li>이용자가 서비스상에 게재되어 있는 광고를 이용하거나 서비스를 통한 광고주의 판촉활동에 참여하는 등의 방법으로 교신 또는 거래를 하는 것은 전적으로 이용자와 광고주 간의 문제입니다. 만약 이용자와 광고주간에 문제가 발생할 경우에도 이용자와 광고주가 직접 해결하여야 하며, 이와 관련하여 회사가 광고주의 위법행위에 적극 가담하였다 거나, 위법행위를 고의 또는 중과실로 방치하였다는 등의 사정이 없는 한 회사는 어떠한 책임도 부담하지 않습니다.</li>
        </ol>

        <p>&nbsp;</p>
        <h3>제17조 (회원의 게시물)</h3>
        <ol>
          <li>회사는 이용자가 게시하거나 전달하는 서비스 내의 모든 게시물(텍스트, 이미지, 동영상, 각종 파일, 링크, 댓글 등을 모두 포함)이 다음 각 호의 어느 하나에 해당한다고 판단되는 경우 사전 통지 없이 삭제할 수 있으며, 이에 대해 회사는 어떠한 책임도 지지 않습니다.
            <ol>
              <li>다른 회원 또는 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우</li>
              <li>공공질서 및 미풍양속에 위반되는 내용일 경우</li>
              <li>범죄적 행위에 결부된다고 인정되는 내용일 경우</li>
              <li>제3자의 저작권 등 기타 권리를 침해하는 내용인 경우</li>
              <li>서비스 성격에 부합하지 않는 정보의 경우</li>
              <li>음란성 게시물 또는 외설적인 내용으로 성적 수치심과 불쾌감을 유발하는 내용일 경우</li>
              <li>규정한 게시기간을 초과하거나 반복적으로 같은 내용을 등록하는 경우</li>
              <li>기타 관련 법령 등에 위배되는 경우</li>
            </ol>
          </li>
          <li>이용자가 서비스에 등록하는 게시물 등으로 인하여 본인 또는 타인에게 손해나 기타 문제가 발생하는 경우 이용자는 이에 대한 책임을 지게 되며, 회사는 특별한 사정이 없는 한 이에 대하여 책임을 지지 않습니다.</li>
        </ol>
        <p>&nbsp;</p>

        <h3>제18조 (게시물의 저작권)</h3>
        <ol>
          <li>서비스 내에 게재된 자료에 대한 권리와 책임은 게시자에게 있습니다. 회사는 게시자의 동의가 없는 한, 이를 영리적인 목적으로 사용할 수 없습니다. </li>
          <li>이용자는 자신의 게시물을 회사가 국내외에서 다음 각 호의 어느 하나의 목적으로 사용할 수 있음에 동의합니다.
            <ol>
              <li>회사의 서비스 또는 회사의 공식 사이트 이외의 업무와 연계된 사이트 내에서 이용자의 게시물의 복제, 전송, 전시 및 우수 게시물을 노출하기 위하여 이용자 게시물의 크기 변환, 이미지 변경, 등의 방식으로 수정하는 것</li>
              <li>회사의 서비스를 홍보하기 위한 목적으로 온/오프라인 사용, 미디어, 언론기관 등에게 이용자의 게시물 내용을 보도, 방영하게 하는 것. 단, 이 경우 회사는 이용자의 개별 동의 없이 미디어, 언론기관 등에게 개인정보를 제공하지 않습니다. </li>
            </ol>
          </li>
          <li>2항의 규정에도 불구하고 회사가 이용자의 게시물을 전 항 각 호의 어느 하나에 기재된 목적 이외의 방법으로 사용하는 경우에는 사전에 해당 이용자로부터 동의를 얻어야 합니다. 게시물에 대한 회사의 사용 요청, 이용자의 동의 및 동의 철회 절차는 전화, 전자우편 등 회사가 요청하는 방식에 따릅니다. 또한 회사는 게시물의 출처 의무 표기합니다. </li>
          <li>이용자가 서비스의 이용계약을 해지하더라도 이용자의 명의로 서비스에 등록한 게시물을 삭제되지 않습니다. 이용자는 자신의 게시물이 회원 탈퇴 후 서비스에서 이용되는 것을 원하지 않는 경우 회원 탈퇴 전에 직접 게시물을 삭제하여야 합니다. (단, 제3자가 다시 게시하거나 저장한 게시물은 삭제되지 않을 수 있습니다.)</li>
          <li>회사는 회사의 운영정책상의 판단, 합병, 영업양도 등의 사유로 원래의 게시물의 내용을 변경하지 않고 게시물의 게시 위치를 변경할 수 있습니다.</li>
          <li>회사에서 작성한 저작물에 대한 저작권 및 기타 지적재산권은 회사에 귀속합니다. 이용자는 서비스를 이용하여 얻은 정보를 회사의 사전 승낙없이 복제, 송신, 출판, 배포, 방송, 가공, 판매하는 행위 등 서비스 내에 게재된 자료를 상업적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다. </li>
          <li>이용자의 게시물이 타인의 저작권, 프로그램 저작권 등을 침해함으로써 발생하는 민, 형사상의 책임은 전적으로 이용자가 부담하여야 합니다. </li>
        </ol>
        <p>&nbsp;</p>

        <h3>제19조 (계약 해제, 해지 등)</h3>
        <ol>
          <li>회원이 이용계약을 해지하고자 하는 때에는 회원 본인이 회사에 해지신청을 하거나 웹 사이트 및 모바일 어플리케이션에서 회원 탈퇴하기 버튼을 클릭하고 이에 따른 탈퇴 절차를 거침으로써 이용계약을 해지할 수 있습니다. 회사는 관련법령 등에서 정하는 바에 따라 이를 즉시 처리하여야 합니다.</li>
          <li>회원이 계약을 해지할 경우, 관련법 및 개인정보처리방침에 따라 회사가 회원정보를 보유하는 경우를 제외하고는 해지 즉시 회원의 모든 데이터는 소멸됩니다.</li>
        </ol>
        <p>&nbsp;</p>

        <h3>제20조 (이용제한 등)</h3>
        <ol>
          <li>회사는 이용자가 이 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고, 일시정지, 영구이용정지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다.</li>
          <li>회사는 전항에도 불구하고, "저작권법" 및 "컴퓨터프로그램보호법"을 위반한 불법프로그램의 제공 및 운영방해, "정보통신망법"을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 영구 이용정지를 할 수 있습니다. 본 항에 따른 영구이용정지 시 서비스 이용을 통해 획득한 혜택 등은 모두 소멸되며, 회사는 이에 대해 별도로 보상하지 않습니다.</li>
          <li>회사는 본 조의 이용제한 범위 내에서 제한의 조건 및 세부내용은 서비스의 운영정책에서 정하는 바에 의합니다.</li>
          <li>본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우에는 회사는 제11조[이용자에 대한 통지]에 따라 통지합니다.</li>
          <li>이용자는 본 조에 따른 이용 제한 등에 대해 회사가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우 회사는 즉시 서비스의 이용을 재개합니다.</li>
        </ol>
        <p>&nbsp;</p>

        <h3>제21조 (손해배상)</h3>
        <ol>
          <li>회사는 서비스 이용과 관련하여 이용자에게 발생한 손해에 대하여, 회원의 손해가 회사의 고의 또는 중과실에 의한 위법행위로 한하여 발생한 경우가 아닌 한 책임을 지지 않습니다.</li>
        </ol>
        <p>&nbsp;</p>

        <h3>제22조(면책조항)</h3>
        <ol>
          <li>회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다. </li>
          <li>회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다. </li>
          <li>회사는 회원이 서비스를 이용하여 기대하는 손익이나 서비스를 통해 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다. </li>
          <li>회사는 회원이 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 관하여 책임을 지지 않습니다.</li>
          <li>회원이 이 약관의 규정을 위반함으로 인하여 회사나 회원 또는 제3자에 대하여 책임을 부담하게 되고, 이로써 회사에 손해가 발생하는 경우, 이 약관을 위반한 회원은 회사에 발생하는 모든 손해를 배상하여야 하며, 동 손해로부터 회사를 면책시켜야 합니다. </li>
        </ol>
        <p>&nbsp;</p>

        <h3>제23조(분쟁해결)</h3>
        <ol>
          <li>회사와 이용자는 서비스와 관련하여 발생한 분쟁을 원활하게 해결하기 위하여 필요한 모든 노력을 하여야 합니다.</li>
          <li>제1의 규정에도 불구하고 서비스 이용으로 발생한 분쟁에 대해 소송이 제기될 경우 회사 본사 소재지를 관할하는 법원을 관할 법원으로 합니다. </li>
        </ol>
        <p>&nbsp;</p>

        <h3>제24조(회사의 연락처)</h3>
        <p className='font12'>상 &nbsp;&nbsp; 호 :  주식회사 듀얼헬스케어</p>
        <p className='font12'>대표자 : 김영이</p>
        <p className='font12'>주 &nbsp;&nbsp; 소 : 대전시 유성구 대덕대로512번길20, A동 2층</p>
        <p className='font12'>대표전화 : 1661-2645</p>
        <p className='font12'>이메일주소 : <a href="mail to:help@dual.health">help@dual.health</a></p>
        <p>&nbsp;</p>


        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <p>본 약관은 2021년 1월 19일부터 시행합니다.</p>
        <p>&nbsp;</p>
        <p>공지일자 : 2021년 1월 19일</p>
        <p>&nbsp;</p>
        <p>시행일자 : 2021년 1월 19일</p>

      </Box>



      <Bottom />

    </Container>

  );
}


export default Terms;